export default __webpack_public_path__ + "static/media/SuciuAntonio.4e763bd5.jpeg";